<template>
  <b-container fluid>
    <b-row class="details">
      <b-col xl="12" lg="12" sm="12">
            <iq-card>
                <template v-slot:body>
                    <b-row>
                        <b-col xl="12" lg="12" sm="12">
                                <b-table-simple striped bordered small hover>
                                 <tbody>
                                    <b-tr>
                                        <b-td>{{ $t('institute_manangement.organization_name') }}</b-td>
                                        <b-td colspan="3">{{ getOrgName(detailsFormData.org_id) }}</b-td>
                                    </b-tr>
                                     <b-tr>
                                        <b-td>{{ $t('institute_manangement.institute_type') }}</b-td>
                                        <b-td>{{ getInstituteType(detailsFormData.office_type_id) }}</b-td>
                                        <b-td>{{ $t('institute_manangement.institute_name') }}</b-td>
                                        <b-td>{{ getInstituteName(detailsFormData.office_id) }}</b-td>
                                    </b-tr>
                                    <b-tr>
                                        <b-td>{{$t('institute_manangement.food_item')}}</b-td>
                                        <b-td colspan="3"><span>
                                            {{ getFoodItem(detailsFormData.food_item_id) }}</span></b-td>
                                    </b-tr>
                                 </tbody>
                            </b-table-simple>
                            <div class="row">
                                <div class="col-sm-12">
                                      <h5>{{  $t('institute_manangement.img_food_item') }}</h5>
                                    <div lg="8" md="8" class="text-center">
                                        <b-img v-if="detailsFormData.image !== null" width='135px' height="130px" :src="childServiceBaseUrl+'download-attachment?file=uploads/food-management/original/' + detailsFormData.image" fluid alt="Image"></b-img>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-3"></div>
                                <div class="col text-right">
                                    <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-2')">{{ $t('globalTrans.close') }}</b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </template>
            </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { mapGetters } from 'vuex'
import { core } from '../../../../../config/pluginInit'
import { childServiceBaseUrl } from '../../../../../config/api_config'

export default {
    props: ['id'],
    components: {
    },
    created () {
        if (this.id) {
            const tmp = this.getInstituteInfoData()
            this.detailsFormData = tmp
        }
    },
    mounted () {
        core.index()
    },
    data () {
        return {
            detailsFormData: {},
            childServiceBaseUrl: childServiceBaseUrl
        }
    },
    computed: {
        orgList: function () {
            return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
        },
        officeTypeList: function () {
            return this.$store.state.commonObj.officeTypeList
        },
        officeList: function () {
            return this.$store.state.commonObj.officeList
        },
        foodList: function () {
            return this.childCommonObj.foodList
        },
        currentLocale () {
            return this.$i18n.locale
        },
        ...mapGetters({
            childCommonObj: 'ChildService/commonObj'
        })
    },
    methods: {
        getFoodItem (typeId = null) {
            const institute = this.foodList.find(institute => institute.value === typeId)
            if (this.$i18n.locale === 'bn') {
                return institute.text_bn
            } else {
               return institute.text_en
            }
        },
        getInstituteInfoData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        getOrgName (orgId) {
            const organization = this.orgList.find(org => org.value === orgId)
            if (this.$i18n.locale === 'bn') {
                return organization.text_bn
            } else {
               return organization.text_en
            }
        },
        getInstituteType (typeId) {
            const institute = this.officeTypeList.find(institute => institute.value === typeId)
            if (this.$i18n.locale === 'bn') {
                return institute.text_bn
            } else {
               return institute.text_en
            }
        },
        getInstituteName (InstId) {
            const institute = this.officeList.find(institute => institute.value === InstId)
            if (this.$i18n.locale === 'bn') {
                return institute.text_bn
            } else {
               return institute.text_en
            }
        }
    }
}

</script>
<style lang="scss">
    .details {
    h5 {
      color: green !important;
      font-size: 20px !important;
    }
    .table-bordered td:nth-child(2n+1) {
      font-weight: 700;
    }
  }
  .hidden_header {
    display: none
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
</style>
